import api from '@/services/api';

export interface UploadImageResponse {
  url: string;
}

export const uploadService = {
  async uploadImage(file: File): Promise<UploadImageResponse> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post<UploadImageResponse>('/uploads/images', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};
